import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import Dialog from '../../components/SMOrganisations/UpdLicenseCountDialog';
import {
  makeSelectDialogParams,
  makeSelectIsDialogOpen,
  setDialog,
} from '../../lib/store/reducers/dialog';
import { DIALOG_TYPES } from '../../lib/constants/dialog-types';
import { EDIT_ORG } from '../../lib/api/graphql/mutations/organizations';
import { GET_ORGANIZATION } from '../../lib/api/graphql/queries/organizations';
import { showNotification } from '../../lib/store/actions/notifications';
import { NOTIFICATION_TYPES } from '../../lib/constants/notification-types';

const UpdLicenseDialog = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const isOpen = useSelector(
    makeSelectIsDialogOpen(DIALOG_TYPES.UPDATE_ORG_LICENSE),
  );
  const { organisation } = useSelector(makeSelectDialogParams()) || {};

  const [editOrg, { loading: isEditingName }] = useMutation(EDIT_ORG, {
    refetchQueries: [
      { query: GET_ORGANIZATION, variables: { orgId: param?.id } },
    ],
    onCompleted: () => {
      handleClose();
    },
    onError: () => {
      dispatch(
        showNotification({
          options: { variant: NOTIFICATION_TYPES.Error },
          message: 'Error editing organisation details',
        }),
      );
    },
  });

  const handleUpdateLicence = async ({ licences }) => {
    await editOrg({
      variables: {
        orgId: param.id,
        licences: licences,
      },
    });
  };

  const handleClose = () => {
    dispatch(
      setDialog({
        open: false,
        dialog: DIALOG_TYPES.UPDATE_ORG_LICENSE,
      }),
    );
  };

  if (!organisation) return null;

  return (
    <Dialog
      isUpdating={isEditingName}
      licences={organisation?.licences || 0}
      members={organisation?.activeMembers || 0}
      isOpen={isOpen}
      onCancel={handleClose}
      onSubmit={handleUpdateLicence}
    />
  );
};

export default UpdLicenseDialog;
